import { Table, TableCell, TableContainer, TableRow } from "@mui/material";
import { ContractPerson } from "@repo/api";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import * as Styled from "./PersonsAccordion.styled";

type PersonDetailPersonalDataProps = {
    person: ContractPerson,
    birthDateFormatted: string
}
export const PersonDetailPersonalData: FC<PersonDetailPersonalDataProps> = ({
    person,
    birthDateFormatted
}) => {
    const { t } = useTranslation();

    return (
        <TableContainer>
            <Table>
                <Styled.PersonsAccordionTableBody>
                    <TableRow>
                        <TableCell>{t("global.name")}</TableCell>
                        <TableCell>{person.person.firstName}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>{t("global.surname")}</TableCell>
                        <TableCell>{person.person.lastName}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>{t("global.birthDate")}</TableCell>
                        <TableCell>{birthDateFormatted}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>{t("global.birthNumber")}</TableCell>
                        <TableCell>{person.person.birthNumber ?? t("global.emptyValue")}</TableCell>
                    </TableRow>
                    <TableRow>
                        <Styled.PersonsAccordionLastCell>{t("global.citizenship")}</Styled.PersonsAccordionLastCell>
                        <Styled.PersonsAccordionLastCell>{person.person.citizenship ?? t("global.emptyValue")}</Styled.PersonsAccordionLastCell>
                    </TableRow>
                </Styled.PersonsAccordionTableBody>
            </Table>
        </TableContainer>
    );
}
